import DataJson from "../../static/api/articles.json";

const groupBy = (list, keyGetter) => {
    const map = new Map();
    
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });

    return map;
}

const __Areas__ = groupBy(DataJson, c => c.Mainland);

const __CurrentAreas__ = (area) => {
    if (!area) return;
    var _areas = [];

    __Areas__.forEach(obj => {
        if (obj[0].Order == area) {
            _areas.push(obj);
        }
    });

    return _areas[0];
}

const __AreasLabel__ = (order) => {
    if (!order) return;
    var _areas = [];

    __Areas__.forEach(obj => {
        _areas.push({
            Mainland: obj[0].Mainland,
            Land: obj[0].Land,
            Order: obj[0].Order
        })
    });

    _areas.sort((a, b) => a.Order - b.Order);

    return _areas.filter(a => a.Order == order)[0].Mainland;
}

const __AreasMenuLabel__ = () => {
    var _areas = [];

    __Areas__.forEach(obj => {
        _areas.push({
            Mainland: obj[0].Mainland,
            Land: obj[0].Land,
            Order: obj[0].Order
        })
    });

    _areas.sort((a, b) => a.Order - b.Order);

    return _areas;
}


export {
    groupBy,
    __Areas__,
    __CurrentAreas__,
    __AreasMenuLabel__,
    __AreasLabel__
}


// WEBPACK FOOTER //
// ./src/Components/Helpers/ArrayGrouping.js